import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {
    clearVehicleErrorMsg,
    deleteAVehicle,
    loadVehiclesData,
    saveAVehicle,
    updateAVehicle
} from "../../redux/modules/vehicle";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import GridList from "@material-ui/core/GridList";
//import CardUserInformation from "./CardUserInformation";
import CardVehicleInformation from "./CardVehicleInformation";
import * as MainConstants from "../../utils/MainConstants";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import {decodeVin} from "../../redux/modules/vin";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#e2580d",
        color: "black",
    },
    button2: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#e2580d",
        fontSize: theme.typography.pxToRem(10),
        color: "black",
    },
    gridList: {
        width: 500,
        height: 400,
    },
});


class VehicleForm extends React.Component {
    
    
    state = {
        
        //selectedLocation:{},
        
        selectedVehicle: { "country": "U.S.A", "state": "Massachusetts" },
        inputFieldShrinkYear: true,
        alterState: true,
        showVehicleSavedDialog: false,
        
    };
    
    constructor(props) {
        super(props);
        this.vehicleCardList = null;
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        //this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
        //this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        //this.handleLastnameChange = this.handleLastnameChange.bind(this);
        
        this.handlePlatenumberChange = this.handlePlatenumberChange.bind(this);
        
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.handleMakeChange = this.handleMakeChange.bind(this);
        this.handleModelChange = this.handleModelChange.bind(this);
        this.getListOfVehicles = this.getListOfVehicles.bind(this);
        this.handleVINChange = this.handleVINChange.bind(this);
        this.handleDecodeVin = this.handleDecodeVin.bind(this);
        this.handleBodyChange = this.handleBodyChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleVehicleCountrySelectionChange = this.handleVehicleCountrySelectionChange.bind(this);
        this.handleVehicleStateSelectionChange = this.handleVehicleStateSelectionChange.bind(this);
        this.setTheVehicleInformation = this.setTheVehicleInformation.bind(this);
        
        this.handleClickShowSavedVehicle = this.handleClickShowSavedVehicle.bind(this);
        this.handleClickShowSavedVehicleClose = this.handleClickShowSavedVehicleClose.bind(this);
        
        
        
        //this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        //this.handleVehiclenameChange = this.handleVehiclenameChange.bind(this);
        //this.handleLocationChange = this.handleLocationChange.bind(this);
        
        
    }
    
    
    
    handleClickShowSavedVehicle() {
        this.setState({ showVehicleSavedDialog: true });
    };
    
    
    handleClickShowSavedVehicleClose() {
        let { clearVehicleErrorMsg } = this.props;
        this.setState({ showVehicleSavedDialog: false });
        clearVehicleErrorMsg();
    };
    
    handleSubmit() {
        
        
        let { saveAVehicle } = this.props;
        
        //var tempStream = this.state.selectedVehicle ;
        var tempStream = {};
        tempStream = this.setTheVehicleInformation(tempStream);
        //tempStream.locationId= this.state.selectedLocation.id;
        saveAVehicle(DEFAULT_VESPAAN_SERVER.url, tempStream);
        
    };
    
    handleUpdate() {
        let { updateAVehicle } = this.props;
        
        //var tempStream = this.state.selectedVehicle ;
        var tempStream = {};
        tempStream = this.setTheVehicleInformation(tempStream);
        //tempStream.locationId= this.state.selectedLocation.id;
        updateAVehicle(DEFAULT_VESPAAN_SERVER.url, tempStream);
        
    };
    
    setTheVehicleInformation(returnTowjob) {
        
        returnTowjob.id = this.state.selectedVehicle.id;
        returnTowjob.model = this.props.decodedVinVehicleObject.model;
        returnTowjob.make = this.props.decodedVinVehicleObject.make;
        returnTowjob.year = this.props.decodedVinVehicleObject.year;
        returnTowjob.color = this.state.selectedVehicle.color;
        returnTowjob.platenumber = this.state.selectedVehicle.platenumber;
        returnTowjob.state = this.state.selectedVehicle.state;
        returnTowjob.vin = this.state.selectedVehicle.vin;
        returnTowjob.country = this.state.selectedVehicle.country;
        returnTowjob.body = this.props.decodedVinVehicleObject.body;
        returnTowjob.type = this.props.decodedVinVehicleObject.type;
        return returnTowjob;
        
        
    }
    
    handleModelChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.props.decodedVinVehicleObject.model, { model: event.target.value }));
    }
    handleMakeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.props.decodedVinVehicleObject.make, { make: event.target.value }));
    }
    handleBodyChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.props.decodedVinVehicleObject.body, { body: event.target.value }));
    }
    handleTypeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.props.decodedVinVehicleObject.type, { type: event.target.value }));
    }
    
    handleYearChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedVehicle, { year: event.target.value }));
    }
    
    
    handleColorChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedVehicle, { color: event.target.value }));
    }
    
    handlePlatenumberChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedVehicle, { platenumber: event.target.value }));
    }
    
    handleVINChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedVehicle, { vin: event.target.value }));
    }
    
    
    
    
    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedVehicle, { state: event.target.value }));
    }
    
    /*
    
        handleModelChange(event) {
            //event.preventDefault();
            this.setState(Object.assign(this.state.selectedVehicle,{model:event.target.value}));
        }
    */
    
    
    
    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkYear: true
        }));
        
        
        var tempSelectedVehicle = Object.assign({}, this.state.selectedVehicle);
        Object.keys(tempSelectedVehicle).map((key, index) => {
            tempSelectedVehicle[key] = "";
        });
        this.setState({ selectedVehicle: tempSelectedVehicle })
        
        
        
        
    };
    renderErrorFiled(data) {
    
    
    }
    handleVehicleStateSelectionChange(event) {
        //this.setState({selectedState: event.target.value});
        this.setState(Object.assign(this.state.selectedVehicle, { state: event.target.value }));
        this.setState({ numberShrink: true });
    }
    
    handleVehicleCountrySelectionChange(event) {
        this.setState(Object.assign(this.state.selectedVehicle, { country: event.target.value }));
        
    }
    
    refresh(event) {
        let { loadVehiclesData } = this.props;
        loadVehiclesData(DEFAULT_VESPAAN_SERVER.url);
    }
    
    getListOfVehicles() {
        let tempArray = this.props.vehiclesArray;
        let returnArray = [];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                s.editMode = false;
                return (
                  
                  <CardVehicleInformation info={s} onEdit={this.editRecord} onDelete={this.deleteRecord}></CardVehicleInformation>
                   );
            });
        }
        return (returnArray);
    }
    
    handleDecodeVin() {
        let { decodeVin } = this.props;
        decodeVin(this.state.selectedVehicle.vin);
    }
    
    render() {
        const { classes } = this.props;
        this.vehicleCardList = this.getListOfVehicles();
        let usStates = MainConstants.getUSStates();
        let canStates = MainConstants.getCanadaStates();
        let availableCountries = MainConstants.getCountries();
        return (
          <React.Fragment>
              <Typography variant="h6" gutterBottom>
                  Vehicle Information
              </Typography>
              <Grid container spacing={24}>
                  
                  <Grid item xs={12} sm={12}>
                      
                      <Grid container >
                          <Grid item xs={5} sm={5}>
                              <Grid container >
                                  <Grid item xs={5} sm={5}>
                                      <TextField id="vinnumber" name="vinnumber" label="VIN" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedVehicle.vin} onChange={this.handleVINChange} />
                                  </Grid>
                                  
                                  <Grid item xs={2} sm={2}>
                                      <Button variant="contained" color="primary" className={classes.button2} onClick={(event) => this.handleDecodeVin()} >
                                          decode VIN
                                      </Button>
                                  </Grid>
                                  {((this.props.decodedVinVehicleObject.errorCode != 0) && (this.props.decodedVinVehicleObject != undefined) && (this.props.decodedVinVehicleObject.errorCode != undefined)) && (
                                    
                                    <Grid item xs={4} sm={4} >
                                        <Typography variant="subtitle1" color='secondary' gutterBottom>
                                            VIN decoding failed, please check the VIN and try again.  Error:  {this.props.decodedVinVehicleObject.errorText}
                                        </Typography>
                                    </Grid>)}
                                  {((this.props.decodedVinVehicleObject.errorCode == 0) || (this.props.decodedVinVehicleObject == undefined) || (this.props.decodedVinVehicleObject.errorCode == undefined)) && (
                                    
                                    <Grid item xs={4} sm={4} >
                                        <Typography variant="subtitle1" gutterBottom>
                                        
                                        </Typography>
                                    </Grid>)}
                              </Grid>
                              <Grid container >
                                  <Grid item xs={5} sm={5}>
                                      <TextField required id="body" name="body" label="Body" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.body} onChange={this.handleBodyChange} />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="type" name="type" label="Type" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.type} onChange={this.handleTypeChange} />
                                  </Grid>
                              
                              </Grid>
                              <Grid container >
                                  <Grid item xs={5} sm={5}>
                                      <TextField required id="make" name="make" label="Make" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.make} onChange={this.handleMakeChange} />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="model" name="model" label="Model" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.model} onChange={this.handleModelChange} />
                                  </Grid>
                              
                              </Grid>
                              
                              <Grid container >
                                  <Grid item xs={5} sm={5} >
                                      <TextField id="year" name="year" label="Year" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.year} onChange={this.handleYearChange} />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="color" name="color" label="Color" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedVehicle.color} onChange={this.handleColorChange} />
                                  </Grid>
                              </Grid>
                              
                              <Grid container >
                                  <Grid item xs={5} sm={5}>
                                      <TextField id="plateNumber" name="plateNumber" label="PlateNumber" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedVehicle.platenumber} onChange={this.handlePlatenumberChange} />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      {/*} <TextField  required id="state" name="state" label="State"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }}  value={this.state.selectedVehicle.state} onChange={this.handleStateChange}  />
                            */}
                                  </Grid>
                              </Grid>
                              
                              
                              <Grid container spacing={24} >
                                  
                                  <Grid item xs={3} sm={3} >
                                      {/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                                       */}
                                      <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper">Country</InputLabel>
                                          <Select value={this.state.selectedVehicle.country}
                                                  onChange={this.handleVehicleCountrySelectionChange}
                                                  inputProps={{
                                                      name: 'country',
                                                      id: 'country-helper',
                                                  }}
                                          >
                                              
                                              {availableCountries}
                                          
                                          </Select>
                                      
                                      </FormControl>
                                  
                                  
                                  </Grid>
                                  
                                  
                                  <Grid item xs={3} sm={3} >
                                      <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper">State</InputLabel>
                                          <Select value={this.state.selectedVehicle.state}
                                                  onChange={this.handleVehicleStateSelectionChange}
                                                  inputProps={{
                                                      name: 'state',
                                                      id: 'state-helper',
                                                  }}
                                          >
                                              
                                              {(this.state.selectedVehicle.country == "U.S.A") && (usStates)}
                                              {(this.state.selectedVehicle.country != "U.S.A") && (canStates)}
                                          
                                          
                                          </Select>
                                          {/* <FormHelperText>Select a State </FormHelperText> */}
                                      </FormControl>
                                  
                                  </Grid>
                              </Grid>
                              
                              <Grid container >
                                  
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                                          Add Vehicle
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                                          Update Vehicle
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                                          Clear Fields
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                                          Refresh List
                                      </Button>
                                  </Grid>
                              
                              </Grid>
                          </Grid>
                          
                          <Grid item xs={1} sm={1} >
                          </Grid>
                          <Grid item xs={6} sm={6}>
                              {/*<DynamicTable  data={this.props.vehiclesArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable> */}
                              {  (this.props.vehiclesArray.length > 1) &&
                                (
                              <Typography variant="h6" gutterBottom>
                                  There are {this.props.vehiclesArray.length}  vehicles in your profile.
                              </Typography>)}
                              {  (this.props.vehiclesArray.length === 1) &&
                                (
                                  <Typography variant="h6" gutterBottom>
                                      There is {this.props.vehiclesArray.length}  vehicle in your profile.
                                  </Typography>)}
                              {  (this.props.vehiclesArray.length === 0) &&
                                (
                                  <Typography variant="h6" gutterBottom>
                                      There is no  vehicle in your profile.
                                  </Typography>)}
                              
                              <GridList cellHeight={100} className={classes.gridList}>
                                  {this.vehicleCardList}
                              </GridList>
                          </Grid>
                      
                      </Grid>
                      
                      
                      
                      
                      
                      <Grid container >
                          {(this.props.errorCMsg) && (this.props.errorCMsg.message) && (
                            <Grid item xs={12}   >
                                <TextField error id="outlined-error" label="Error - Operation Failed" value={" message = " + this.props.errorCMsg.response.data.message + " details = " + this.props.errorCMsg.response.data.details + " Time = " + this.props.errorCMsg.response.data.timestamp}
                                           className={classes.textField} margin="normal" variant="outlined" disabled={true} multiline={true} />
                            </Grid>)
                          }
                          
                          {/*
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                    */}
                      </Grid>
                  </Grid>
                  {/* This is for submit event error/success display */}
                  <Dialog
                    open={this.state.showVehicleSavedDialog}
                    onClose={this.handleClickShowSavedVehicleClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Vehicle Information</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          
                          {(this.props.errorCMsg != null) && (this.props.errorCMsg.status == 200) && (<div>
                              The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
                          </div>)}
                          { (this.props.errorCMsg != null) &&  (this.props.errorCMsg.status != null) && (<div>
                              The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
                          </div>)}
                      
                      </DialogContent>
                      <DialogActions>
                          {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
                          
                          <Button onClick={this.handleClickShowSavedVehicleClose} color="secondary">Close</Button>
                      </DialogActions>
                  </Dialog>
              
              
              
              </Grid>
          </React.Fragment>
        );
    }//end of render
    
    
    
    editRecord(singleRowData) {
        this.setState({ inputFieldShrinkYear: true });
        this.setState({ selectedVehicle: singleRowData });
        if ((singleRowData != null) && (singleRowData != undefined) && (singleRowData.make != undefined) && (singleRowData.model != undefined)) {
            this.setState(Object.assign(this.props.decodedVinVehicleObject, { model: singleRowData.model }));
            this.setState(Object.assign(this.props.decodedVinVehicleObject, { make: singleRowData.make }));
            this.setState(Object.assign(this.props.decodedVinVehicleObject, { type: singleRowData.type }));
            this.setState(Object.assign(this.props.decodedVinVehicleObject, { body: singleRowData.body }));
            this.setState(Object.assign(this.props.decodedVinVehicleObject, { year: singleRowData.year }));
        }
        
        
        for (var i = 0; i < this.vehicleCardList.length; i++) {
            if (this.vehicleCardList[i].props.info.id != singleRowData.id) {
                this.vehicleCardList[i].props.info.editMode = true;
            } else {
                this.vehicleCardList[i].props.info.editMode = false;
            }
            
        }
        
        
        
        if (this.setState.alterState == false) {
            this.setState({ alterState: true });
        } else {
            this.setState({ alterState: false });
        }
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );
        
        //this.setState({selectedLocation:tempLocation });
        
    }
    
    
    deleteRecord(argProcessId) {
        //alert('I am deleting ' + argCameraId);
        let { deleteAVehicle } = this.props;
        deleteAVehicle(DEFAULT_VESPAAN_SERVER.url, argProcessId);
    }
    
    
    componentWillMount() {
        let { loadVehiclesData, loadLocationsData } = this.props;
        loadVehiclesData(DEFAULT_VESPAAN_SERVER.url);
        //loadLocationsData("http://localhost:9065/" );
        
        this.setState({
            errorCMsg: {}
        });
        
        
    }
    
    /*componentWillReceiveProps(nextProps) {
        if (this.props.vehiclesArray !== nextProps.vehiclesArray) {
            this.setState({
                vehiclesArray: nextProps.vehiclesArray
            });
        }
    }*/
    
    componentWillReceiveProps(nextProps) {
        if (nextProps.errorCMsg != null) {
            if (nextProps.errorCMsg.status != null) {
                this.handleClickShowSavedVehicle();
            }
        }
    }
    
    
    
}//end of class

VehicleForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapYearToProps = (state) => {
    return {
        vehiclesArray: state.vehicle.vehiclesArray,
        VehicleDeleteResponse: state.vehicle.deleteVehicleResp,
        VehicleSaveResponse: state.vehicle.saveVehicleResp,
        decodedVinVehicleObject: state.vin.decodedVinVehicleObject,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg: state.vehicle.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadVehiclesData: loadVehiclesData,
        deleteAVehicle: deleteAVehicle,
        saveAVehicle: saveAVehicle,
        updateAVehicle: updateAVehicle,
        decodeVin: decodeVin,
        clearVehicleErrorMsg: clearVehicleErrorMsg,
        //loadLocationsData:loadLocationsData,
        //loadVideoControllersData:loadVideoControllersData,
        //loadCamerasData:loadCamerasData,
        
    }, dispatch);
};

export default connect(mapYearToProps, mapDispatchToProps)(withStyles(styles)(VehicleForm));
